<div class="model-base">
    <ng-content></ng-content>
</div>